<template>
  <div>
    <input v-if="show_input" type="text" class="form-control" v-model.lazy="alias"
      :placeholder="meterData.mac_alias ?? meterData.bx_mac">
    <button v-else type="button" class="btn btn-info btn-sm" @click="show_input = true">
      <i class="fa-regular fa-pen-to-square"></i>
    </button>



    <button type="button" class="btn btn-info btn-sm" data-bs-toggle="modal"
      :data-bs-target="`#meterModal${meterData.id}`">
      <i class="fa-regular fa-pen-to-square"></i>
    </button>


    <div class="modal fade" :id="`meterModal${meter.id}`" tabindex="-1" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            ...
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['meterData', 'showInput'],
  data() {
    return {
      show_input: false,
      name: '',
      meter: '',
      alias: ''
    };
  },
  watch: {
    showInput() {
      this.show_input = false;
    },
    alias(alias) {
      const axios_data = {
        "bx_mac": this.$props.meterData.bx_mac,
        "mac_alias": alias
      };
      axios.patch(base_url + "/api/bx/mac/" + this.$store.getters.selectedRegion.id, axios_data)
        .then((response) => {
          this.$store.dispatch('setUserRegions');
          this.alias = '';
        }).catch(function (error) {
          console.error(error.toJSON());
        });
    }
  }
};
</script>

<style scoped>
.btn {
  border-radius: .25rem .7rem .25rem .25rem;
}

.btn-info {
  color: white;
  font-weight: bolder;
}
</style>
